import React, { useRef, useState } from "react";
import Select from "../../../components/form/select/Select";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { riskcovered } from "../../../utils/validators/schema";
import {
  resetRiskCover,
  setRiskCover,
} from "../../../redux/slice/policy/policySlice";
import { v4 as uuidv4 } from "uuid";
import { removeLeadingZeros } from "../../../utils/helpers/filter";

const EditRiskCovered = ({
  modal_id,
  editData,
  setEditData,
  title,
  handleEditData,
  selectedRisks,
  underwriter,
}) => {
  const { single_policy, single_policy_cover } = useSelector(
    (state) => state.policy
  );
  const { underwritingData } = useSelector((state) => state.underwriting);
  const { all_covers } = useSelector((state) => state.cover);

  const [ratePass, setRatePass] = useState(false);

  const close = useRef();
  const riskCoverType = useRef();
  const dispatch = useDispatch();

  const coverTypes = all_covers?.unpaginated_cover
    ?.filter((cover) =>
      single_policy_cover?.policy_cover?.some(
        (element) => String(element.cover) === String(cover.id)
      )
    )
    .map((item) => ({
      value: item.id,
      label: item.name,
    }))
    .filter((coverType) =>
      selectedRisks?.every(
        (risk) => parseInt(risk.cover_type) !== coverType.value
      )
    );

  const handleRateCheck = (e) => {
    if (
      e.target.value >=
        parseFloat(
          underwritingData?.p_interest_info?.minimum_rate ||
            single_policy?.policy_interest_info?.minimum_rate
        ) &&
      e.target.value <=
        parseFloat(
          underwritingData?.p_interest_info?.maximum_rate ||
            single_policy?.policy_interest_info?.maximum_rate
        )
    ) {
      setRatePass(true);
    } else {
      setRatePass(false);
    }
  };

  const onSubmit = (values) => {
    const calAnnPremium = values.sum_insured * (values.rate * 0.01);
    if (editData?.policy_application_number || editData?.policy_id) {
      let payload;
      if (editData?.policy_id) {
        payload = {
          policy_id: editData?.policy_id,
          annualPremium: calAnnPremium,
          coverFor: values?.cover_for,
          policyCoverType: values?.cover_type,
          rate: values?.rate,
          id: editData?.id,
          sumInsured: values?.sum_insured,
          description: values?.description,
        };
      } else {
        payload = {
          ...editData,
          annual_premium: calAnnPremium,
          cover_for: values?.cover_for,
          cover_type: values?.cover_type,
          rate: values?.rate,
          sum_insured: values?.sum_insured,
          description: values?.description,
        };
      }
      handleEditData(payload);
      close.current.click();
      setEditData(null);
      return;
    }
    let payload = {
      ...values,
      annual_premium: calAnnPremium,
      id: editData ? editData.id : uuidv4(),
    };
    dispatch(setRiskCover(payload));
    setEditData(null);
    close.current.click();
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      cover_type: editData ? editData?.cover_type : "",
      cover_for: editData ? editData?.cover_for : "",
      rate: editData
        ? editData?.rate
        : parseFloat(
            underwritingData?.p_interest_info?.default_rate ||
              single_policy?.policy_interest_info?.default_rate
          ),
      sum_insured: editData ? editData?.sum_insured : "",
      description: editData ? editData?.description : "",
    },
    validationSchema: riskcovered,
    validate: (values) => {
      let errors = {};
      if (
        values.rate <
        parseFloat(
          underwritingData?.p_interest_info?.minimum_rate ||
            single_policy?.policy_interest_info?.minimum_rate
        )
      ) {
        errors.rate =
          "rate cannot be less than " +
          parseFloat(
            underwritingData?.p_interest_info?.minimum_rate ||
              single_policy?.policy_interest_info?.minimum_rate
          );
      }
      if (
        values.rate >
        parseFloat(
          underwritingData?.p_interest_info?.maximum_rate ||
            single_policy?.policy_interest_info?.maximum_rate
        )
      ) {
        errors.rate =
          "rate cannot be greater than " +
          parseFloat(
            underwritingData?.p_interest_info?.maximum_rate ||
              single_policy?.policy_interest_info?.maximum_rate
          );
      }
      return errors;
    },
    onSubmit,
  });

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4 text-dark'
            onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                {title}
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  resetForm();
                  riskCoverType?.current?.clearValue();
                  setEditData(null);
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='username' className={`form-label mt-1`}>
                      Policy Cover Type<span className='text-danger'>*</span>
                    </label>
                  </div>
                  {editData?.policy_application_number ||
                  editData?.policy_id ? (
                    <div className='col-md-8'>
                      <input
                        value={
                          all_covers?.unpaginated_cover?.filter(
                            (cover) =>
                              String(cover.id) === String(editData?.cover_type)
                          )[0].name
                        }
                        type='text'
                        readOnly
                        className='form-control form-control-sm '
                      />
                    </div>
                  ) : (
                    <div className='col-md-8'>
                      <Select
                        onBlur={() => {
                          handleBlur({ target: { name: "cover_type" } });
                        }}
                        name='cover_type'
                        id='cover_type'
                        data={coverTypes}
                        value={values?.cover_type}
                        onChange={(selectedOption) =>
                          setFieldValue("cover_type", selectedOption?.value)
                        }
                        ref={riskCoverType}
                        isError={errors?.cover_type && touched?.cover_type}
                      />
                      {errors?.cover_type && touched?.cover_type && (
                        <p className='text-danger mb-0'>{errors?.cover_type}</p>
                      )}
                    </div>
                  )}
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='cover_for' className={`form-label mt-1`}>
                      Cover For<span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='text'
                      id='cover_for'
                      name='cover_for'
                      value={values?.cover_for}
                      readOnly={
                        (editData?.policy_application_number ||
                          editData?.policy_id) &&
                        true
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={`form-control form-control-sm ${
                        errors?.cover_for && touched?.cover_for && "is-invalid"
                      }`}
                    />
                    {errors?.cover_for && touched?.cover_for && (
                      <span className='text-danger'>{errors?.cover_for}</span>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='username' className={`form-label mt-1`}>
                      Rate (%)
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='number'
                      id='rate'
                      name='rate'
                      value={values.rate}
                      onChange={(value) => {
                        handleChange(value);
                        handleRateCheck(value);
                      }}
                      onBlur={handleBlur}
                      className={`form-control form-control-sm no-arrows ${
                        errors?.rate && touched?.rate && "is-invalid"
                      } ${touched.rate && ratePass && "is-valid"}`}
                    />
                    {errors?.rate && touched?.rate && (
                      <span className='text-danger'>{errors?.rate}</span>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='username' className={`form-label mt-1`}>
                      Sum Insured<span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='number'
                      id='sum_insured'
                      name='sum_insured'
                      value={values?.sum_insured}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={`form-control form-control-sm no-arrows ${
                        errors?.sum_insured &&
                        touched?.sum_insured &&
                        "is-invalid"
                      }`}
                      onInput={(e) => removeLeadingZeros(e.target.id)}
                    />
                    {errors?.sum_insured && touched?.sum_insured && (
                      <span className='text-danger'>{errors?.sum_insured}</span>
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='description' className={`form-label mt-1`}>
                      Detail Description / Specification
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <textarea
                      id='description'
                      name='description'
                      className={`form-control form-control-sm`}
                      value={values?.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3 mt-4'>
              <button
                type='button'
                className='btn btn-secondary btn-sm rounded-3'
                data-bs-dismiss='modal'
                onClick={() => {
                  resetForm();
                  riskCoverType?.current?.clearValue();
                  setEditData(null);
                }}
              >
                Close
              </button>
              <button
                type='submit'
                className='btn btn-primary btn-sm rounded-3'
              >
                {editData ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditRiskCovered;
